export default __webpack_public_path__ + "assets/images/undo-play-card-icon.49113e5fd4f38a1f6adcf48a4086daa4.svg";